<template>
  <div class="wrapper">
    <Header class="header" :val="headerTitle" @rental="rental" :type="'order'"></Header>
    <div class="container">
      <!-- content(s) -->
      <div id="content" class="rental">
        <div class="progress">
          <ol>
            <li class="on"><span>주문정보입력</span></li>
            <li><span>결제정보입력</span></li>
          </ol>
        </div>

        <section class="hr">
          <div class="titArea">
            <h2 class="titH4">주문 상품</h2>
          </div>
          <div class="prdList">
            <div class="prdItem xs">
              <div class="imgArea">
                <span class="img"><img v-if="prodInfo.thumbnail" :src="prodInfo.thumbnail" :alt="prodInfo.displayName" /></span>
              </div>
              <div class="infoArea">
                <div class="tit row2">
                  <span>{{ prodInfo.displayName }}</span>
                </div>
                <div class="txtItem">
                  <span>{{ prodInfo.model }}</span>
                </div>
              </div>
            </div>
            <div class="selectedOpt">
              <div class="txtOpt">
                <div class="opt">
                  <span class="item" v-if="color != ''">색상</span>
                  <span class="val">
                    <span v-for="(value, index) in prodColor" :key="index">
                      <template v-if="color == value.colorCode">
                        {{ value.colorCodeNm }}
                      </template>
                    </span>
                  </span>
                </div>
                <div class="opt">
                  <span class="item">수량</span>
                  <span class="val">1개</span>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section class="hr">
          <div class="titArea">
            <h2 class="titH4">배송지 정보</h2>
          </div>

          <div class="formArea">
            <span class="label">이름</span>
            <input type="text" id="customerName" class="ipt" title="이름 입력" value="" v-model="customerName" />

            <span class="label">휴대폰번호</span>
            <input type="tel" id="cellNum" class="ipt" title="휴대폰번호 입력" value="" v-model="cellNum" v-onlyNum />

            <span class="label">생년월일</span>
            <input type="tel" id="ssn" class="ipt" title="YYYYMMDD" placeholder="YYYYMMDD" value="" v-model="ssn" v-onlyNum />

            <span class="label">설치/배송주소</span>
            <div class="setAddr">
              <input
                type="tel"
                id="addr_1"
                class="ipt"
                title="설치 주소 입력 (우편번호)"
                placeholder="우편번호"
                value=""
                readonly="readonly"
                v-model="addrPost"
              />
              <button type="button" class="btn_g m" @click="addrPopupOpen">우편번호찾기</button>
            </div>
            <input
              type="text"
              id="addr_2"
              class="ipt"
              placeholder="기본주소"
              title="설치 주소 입력 (기본주소)"
              value=""
              readonly="readonly"
              v-model="addrRoad"
            />
            <input type="text" id="addr_3" class="ipt" placeholder="상세주소" title="설치 주소 입력 (상세주소)" v-model="addrRemark" />
            <p class="txtList_remark">도서/산간 지역은 설치 불가할 수 있습니다.</p>

            <span class="label">설치/배송 예정일</span>
            <div class="setHalf" style="margin: 0 0px">
              <datepicker
                v-model="installReqDate"
                v-bind:format="format"
                v-bind:input-class="inputClass"
                :disabled-dates="disabledDate"
                v-bind:language="lang"
              ></datepicker>
            </div>

            <span class="label">배송시 요청사항</span>
            <select v-on:input="requestDeliveryChange($event.target.value)" name="requestDelivery" class="ipt jqUI" title="배송시 요청사항">
              <option value="" selected="selected">선택해주세요</option>
              <option v-for="(deliveryRequestCode, index) in deliveryRequestCodeList" :value="deliveryRequestCode.code" :key="index">
                {{ deliveryRequestCode.codeName }}
              </option>
            </select>
            <div v-show="directInpputFlag">
              <input type="text" name="directInput" class="ipt" title="배송시 요청사항 직접입력" value="" v-model="deliReqMemo" />
            </div>
          </div>

          <div class="btnArea sticky">
            <button type="button" class="btn_p" @click="goPaymentStep2()">다음</button>
          </div>
        </section>

        <FindAddr v-if="findAddr" @callback="selectAddr" @close="close"></FindAddr>
        <MessagePop v-if="messagePop" @close="close">
          <p v-html="msg"></p>
        </MessagePop>
        <ConfirmPop @cancel="cancel" @confirm="confirm" v-if="confirmPop" @close="close">
          <p v-html="msg"></p>
        </ConfirmPop>
        <ProgressBar ref="progress"></ProgressBar>
      </div>
      <!-- content(e) -->
    </div>
    <!-- container(e) -->
    <footer class="footer"></footer>
  </div>
</template>

<script>
import ApiService from '@/common/api.service';
import { isEmpty } from '@/common/common.function';
import MessagePop from '@/components/popup/MessagePop';
import FindAddr from '@/components/comm/FindAddr';
import Datepicker from 'vuejs-datepicker';
import { ko } from 'vuejs-datepicker/dist/locale';
import ConfirmPop from '@/components/popup/ConfirmPop';
import { RENTAL_ADD_CART } from '@/store/message.type.js';
import { INPUT_BASKET_COMPLETE } from '@/store/message.type.js';

import JwtService from '@/common/jwt.service';
import ProgressBar from '@/views/app/comm/ProgressBar';
export default {
  name: 'PaymentStep1',
  components: {
    MessagePop,
    FindAddr,
    Datepicker,
    ConfirmPop,
    ProgressBar,
  },
  data: function () {
    return {
      headerTitle: '구매',

      messagePop: false,
      confirmPop: false,
      findAddr: false,
      msg: '',
      productCode: '',
      orderId: '',
      color: null,
      coupon: '',
      couponSerialNumber: '',
      prodInfo: [],
      productDetail: [],
      prodColor: [],
      // IMG_DOMAIN: "'',
      deliveryRequestCodeList: [],

      customerName: '', //이름
      cellNum: '', //휴대폰번호
      ssn: '', //생년월일
      deliReqCd: '', //배송시 요청사항
      deliReqMemo: '', //배송시 요청사항 입력
      directInpputFlag: false,
      // date: new Date(),
      installReqDate: new Date(), //설치/배송일
      installReqDate2: '', //설치/배송일

      addrCode: '',
      addrPost: '',
      addrRoad: '',
      addrJibun: '',
      addrRemark: '',
      nnmb: '',
      zip: '',
      nadr1: '',
      adr1: '',

      format: 'yyyy-MM-dd',
      inputClass: 'ipt date notDel uiAct hasDatepicker',
      calendarClass: 'ui-datepicker ui-widget ui-widget-content ui-helper-clearfix ui-corner-all',
      lang: ko,
      flag: true,
      disabledDate: {
        to: new Date(),
      },

      msgFlag: '',
    };
  },
  created() {
    this.productCode = this.$route.params.productCode;
    this.orderId = this.$route.params.orderId;
    this.color = this.$route.params.color;
    this.coupon = this.$route.params.coupon;
    this.couponSerialNumber = this.$route.params.couponSerialNumber;
    this.order2_productOption1 = this.$route.params.order2_productOption1;
    this.order2_productOption2 = this.$route.params.order2_productOption2;
    this.order2_productOption3 = this.$route.params.order2_productOption3;
    this.saleAmount = this.$route.params.saleAmount;
    this.internalProdCode = this.$route.params.internalProdCode;
    console.log(this.$route.params);
    console.log(this.productCode);
    console.log(this.orderId);
    console.log(this.color);
    console.log(this.coupon);
    console.log(this.couponSerialNumber);
    console.log(this.productDetail);
    //달력 비활성화
    let disabledDate = new Date();
    disabledDate.setDate(disabledDate.getDate() + 6);
    this.disabledDate.to = disabledDate;
    // console.log(this.productCode);
    // console.log(this.orderId);
  },
  mounted: function () {
    console.log(JwtService.getUserInfo());

    const userInfo = JwtService.getUserInfo();

    if (userInfo != null) {
      this.customerName = userInfo.userName;
      this.cellNum = userInfo.mobile;
      this.addrCode = userInfo.addrBdNum;
      this.addrPost = userInfo.addrPost;
      this.addrRoad = userInfo.addrRoad;
      this.addrRemark = userInfo.addrRemark;
      this.addrJibun = userInfo.addrJibun;
    }

    this.defaultDate();

    this.selectProductInfo();
    this.selectCommonCodeList();
  },
  methods: {
    defaultDate() {
      let today = new Date();
      today.setDate(today.getDate() + 7);
      this.installReqDate = today;

      this.installReqDate2 = today.getFullYear() + '-' + this.numberPad(today.getMonth() + 1, 2) + '-' + this.numberPad(today.getDate(), 2);
    },
    numberPad(n, width) {
      n = n + '';
      return n.length >= width ? n : new Array(width - n.length + 1).join('0') + n;
    },
    selectProductInfo() {
      ApiService.service('GET', '/product/' + this.productCode, {
        params: '',
      })
        .then(({ data }) => {
          console.log(data);
          this.prodInfo = data.result.product;
          this.productDetail = data.result.productDetail;
          this.prodColor = data.result.productColors;
          // this.prodDetail = data.result.productDetail;
          // this.prodOption = data.result.productOption;
        })
        .catch(({ response }) => {
          console.log(response);
        });
    },
    selectCommonCodeList() {
      ApiService.service('GET', '/common/code/ITRQ', '')
        .then(({ data }) => {
          this.deliveryRequestCodeList = data.result[0].codeList;
        })
        .catch(({ response }) => {
          console.log(response);
        });
    },
    addrPopupOpen: function () {
      this.findAddr = true;
    },
    selectAddr: function (data) {
      this.addrCode = data.nnmb;
      this.addrPost = data.zip;
      this.addrRoad = data.nadr1;
      this.addrJibun = data.adr1;

      const adr3 = this.addrRemark;
      console.log('@@@@@@@@@@@@@@@@@@@@' + this.productDetail.prodCode);
      const param = {
        nnmb: data.nnmb.toString(),
        nnmz: data.nnmz.toString(),
        addrRoad: data.nadr1,
        ordrNo: this.orderId,
        godsCrtnCd: this.color,
        prdtCd: this.productDetail.prodCode,
        addrPost: this.addrPost,
        plmkAddrGenMCntn: data.adr1,
        plmkAddrSpecMCntn: adr3,
        bldNmSCntn: data.oriBld,
        ldongCdCntn: data.ldongCdCntn,
      };

      ApiService.service('POST', '/common/address-save', param)
        .then((response) => {
          console.log(param);
          // var resultCode = data.isSucceed;

          // if (resultCode) {
          //   this.searchResult = data.result;
          //   this.searchResultLength = data.result.length;
          // }
        })
        .catch(({ response }) => {
          console.log('error : ' + response);
        });

      this.close();
    },
    requestDeliveryChange(value) {
      this.deliReqCd = value;
      if (value == 'ITRQ0099') {
        this.directInpputFlag = true;
      } else {
        this.directInpputFlag = false;
      }
    },
    validate: function () {
      if (isEmpty(this.customerName)) {
        this.msg = '이름을 입력해주세요.';
        this.messagePop = true;
        return false;
      }
      if (isEmpty(this.cellNum)) {
        this.msg = '휴대폰번호를 입력해주세요.';
        this.messagePop = true;
        return false;
      }
      if (isEmpty(this.ssn)) {
        this.msg = '생년월일을 입력해주세요.';
        this.messagePop = true;
        return false;
      }
      if (isEmpty(this.addrPost) || isEmpty(this.addrRoad) || isEmpty(this.addrCode) || isEmpty(this.addrJibun) || isEmpty(this.addrRemark)) {
        this.msg = '설치/배송주소를 입력해주세요.';
        this.messagePop = true;
        return false;
      }
      if (this.ssn.length != 8) {
        this.msg = '생년월일을 8자리로 입력해주세요.';
        this.messagePop = true;
        return false;
      }
      return true;
    },
    goPaymentStep2() {
      if (!this.validate()) {
        return;
      }

      this.installReqDate2 =
        this.installReqDate.getFullYear() +
        '-' +
        this.numberPad(this.installReqDate.getMonth() + 1, 2) +
        '-' +
        this.numberPad(this.installReqDate.getDate(), 2);

      console.log('productCode : ' + this.productCode);
      console.log('productGroupCode : ' + this.prodInfo.productCode);
      console.log('color : ' + this.color);
      console.log('orderId : ' + this.orderId);
      console.log('addrCode : ' + this.addrCode);
      console.log('addrPost : ' + this.addrPost);
      console.log('addrRoad : ' + this.addrRoad);
      console.log('addrJibun : ' + this.addrJibun);
      console.log('addrRemark : ' + this.addrRemark);
      console.log('customerName : ' + this.customerName);
      console.log('cellNum : ' + this.cellNum);
      console.log('deliReqCd : ' + this.deliReqCd);
      console.log('deliReqMemo : ' + this.deliReqMemo);
      console.log('installReqDate : ' + this.installReqDate);
      console.log('installReqDate2 : ' + this.installReqDate2);
      console.log('coupopn : ' + this.coupon);
      console.log('couponSerialNumber: ', this.couponSerialNumber);
      console.log(this.productDetail);
      this.$refs.progress.loadingStart();
      this.$router.push({
        name: 'paymentStep2',
        params: {
          productCode: this.productCode,
          productGroupCode: this.prodInfo.productCode,
          color: this.color,
          orderId: this.orderId,
          addrCode: this.addrCode,
          addrPost: this.addrPost,
          addrRoad: this.addrRoad,
          addrJibun: this.addrJibun,
          addrRemark: this.addrRemark,
          customerName: this.customerName,
          cellNum: this.cellNum,
          yyyymmdd: this.ssn,
          deliReqCd: this.deliReqCd,
          deliReqMemo: this.deliReqMemo,
          installReqDate: this.installReqDate2,
          coupon: this.coupon,
          couponSerialNumber: this.couponSerialNumber,
          productDetail: this.productDetail,
          order2_productOption1: this.order2_productOption1,
          order2_productOption2: this.order2_productOption2,
          order2_productOption3: this.order2_productOption3,
          saleAmount: this.saleAmount,
          internalProdCode: this.internalProdCode,
        },
      });
    },
    rental: function () {
      this.msg = RENTAL_ADD_CART; // 렌탈시작은 GO_HOME 사용 ( MemberMain 등 )
      this.confirmPop = true;
    },
    cancel: function () {
      // 취소 선택시 페이지이동
      this.$router.replace('/');
    },
    confirm: function () {
      // 확인 선택시 장바구니에 담고 페이지이동
      this.msgFlag = 'basket';
      this.confirmPop = false;
      if (JwtService.getToken() == null) {
        this.msg = '로그인이 필요한 페이지 입니다.';
        this.messagePop = true;
        return false;
      }

      let param = new Object();
      let request = new Object();

      request.internalProdCode = this.productDetail.internalProdCode;
      request.colorCode = this.color;
      request.basketCd = 'BSKT0002';

      param.request = request;
      param.serviceType = 'app';
      ApiService.service('POST', '/user/auth/basket', param)
        .then(({ data }) => {
          if (data.isSucceed) {
            this.msg = INPUT_BASKET_COMPLETE;
            this.messagePop = true;
          } else {
            this.msg = data.error;
            this.messagePop = true;
          }
        })
        .catch(({ response }) => {
          console.log(response);
        });
    },
    close() {
      this.messagePop = false;
      this.confirmPop = false;
      this.findAddr = false;

      if (this.msgFlag == 'basket') {
        if (JwtService.getToken() == null) {
          this.$router.replace('/login');
        } else {
          this.cancel();
        }
      }
    },
  },
};
</script>
